<div class="newsletter-page">
  <h1>{{ 'newsletter.unsubscribeTitle' | t }}</h1>

  @if (loading) {
    <div><span class="spinner-border spinner-border-sm mr-1"></span></div>
  }

  @if (state) {
    <p class="muted">{{ 'newsletter.unsubscribeFor' | t: { email: state.email } }}</p>

    @if (done) {
      <div class="alert alert-success" id="unsubscribeDone">{{ 'newsletter.unsubscribeDone' | t }}</div>
    }

    @if (state.subscribed || state.partnerOffers) {
      <div class="choices">
        @if (state.subscribed) {
          <div class="actions">
            <span>{{ 'newsletter.listNewsletter' | t }}</span>
            <button mat-stroked-button type="button" [disabled]="saving" (click)="unsubscribe({ newsletter: false })" id="unsubscribeNewsletter">
              {{ 'newsletter.unsubscribeNewsletter' | t }}
            </button>
          </div>
        }
        @if (state.partnerOffers) {
          <div class="actions">
            <span>{{ 'newsletter.listPartnerOffers' | t }}</span>
            <button mat-stroked-button type="button" [disabled]="saving" (click)="unsubscribe({ partnerOffers: false })" id="unsubscribePartnerOffers">
              {{ 'newsletter.unsubscribePartnerOffers' | t }}
            </button>
          </div>
        }
      </div>
      <button mat-raised-button color="primary" type="button" [disabled]="saving" (click)="unsubscribe({ all: true })" id="unsubscribeAll">
        {{ 'newsletter.unsubscribeAll' | t }}
      </button>
    } @else {
      <div class="alert alert-info" id="unsubscribeNothing">{{ 'newsletter.noSubscription' | t }}</div>
    }
    <p class="muted mt-3">{{ 'newsletter.resubscribeHint' | t }}</p>
  }

  @if (!loading && error) {
    <div class="alert alert-danger">
      <h2>{{ 'auth.invalidLink' | t }}</h2>
      <p>{{ error }}</p>
    </div>
  }
</div>
